<div class="header-container">
  <div mat-dialog-title class="header" [class.bottom-margin]="bottomMargin">
    <ng-content select=".icon"></ng-content>
    <ng-content select="h1"></ng-content>
    <ng-content select=".title"></ng-content>
    <ng-content select="a"></ng-content>
  </div>
  <button
    [mat-dialog-close]="closeButtonReturnValue"
    (click)="onCloseRequested.emit()"
    type="button"
    tabindex="-1"
    mat-icon-button
    aria-label="Close"
    *ngIf="showCloseButton"
  >
    <mat-icon class="notranslate">clear</mat-icon>
  </button>
</div>
